/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useGetWorkflowTypes = makeQueryHook(operations.getWorkflowTypes)

export const useCreateWorkflowType = makeMutationHook(
  operations.createWorkflowType,
)

export const useGetWorkflowTypeById = makeQueryHook(
  operations.getWorkflowTypeById,
)

export const useUpdateWorkflowType = makeMutationHook(
  operations.updateWorkflowType,
)

export const useDeleteWorkflowType = makeMutationHook(
  operations.deleteWorkflowType,
)

export const useGetWorkflowStepTypes = makeQueryHook(
  operations.getWorkflowStepTypes,
)

export const useCreateWorkflowStepType = makeMutationHook(
  operations.createWorkflowStepType,
)

export const useGetWorkflowStepTypeById = makeQueryHook(
  operations.getWorkflowStepTypeById,
)

export const useUpdateWorkflowStepType = makeMutationHook(
  operations.updateWorkflowStepType,
)

export const useDeleteWorkflowStepType = makeMutationHook(
  operations.deleteWorkflowStepType,
)

export const useGetWorkitemTypes = makeQueryHook(operations.getWorkitemTypes)

export const useCreateWorkitemType = makeMutationHook(
  operations.createWorkitemType,
)

export const useGetWorkitemTypeById = makeQueryHook(
  operations.getWorkitemTypeById,
)

export const useUpdateWorkitemType = makeMutationHook(
  operations.updateWorkitemType,
)

export const useDeleteWorkitemType = makeMutationHook(
  operations.deleteWorkitemType,
)

export const useGetCaseWorkflow = makeQueryHook(operations.getCaseWorkflow)

export const useUpdateWorkflowStep = makeMutationHook(
  operations.updateWorkflowStep,
)

export const useUpdateWorkflowWorkitem = makeMutationHook(
  operations.updateWorkflowWorkitem,
)

export const useExportWorkflowTypes = makeMutationHook(
  operations.exportWorkflowTypes,
)

export const useImportWorkflowTypes = makeMutationHook(
  operations.importWorkflowTypes,
)
